<div class="modal-overlay" *ngIf="show" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="header-titles">
        <h3>{{ 'KNOWLEDGE_BASE.SELECT_ARCHIVE.TITLE' | translate }}</h3>
        <p>{{ 'KNOWLEDGE_BASE.SELECT_ARCHIVE.SUBTITLE' | translate }}</p>
      </div>
      <button class="close-btn" (click)="onClose()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>

    <div class="modal-body">
      <div class="search-row">
        <fa-icon [icon]="faSearch" class="search-icon"></fa-icon>
        <input type="text" class="search-input" [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange()"
          [placeholder]="'KNOWLEDGE_BASE.SELECT_ARCHIVE.SEARCH' | translate" />
      </div>

      @if (loading) {
        <div class="state-center">
          <div class="spinner"></div>
        </div>
      } @else if (archives.length === 0) {
        <div class="state-center empty">
          <fa-icon [icon]="faInfoCircle"></fa-icon>
          <p>{{ 'KNOWLEDGE_BASE.SELECT_ARCHIVE.EMPTY' | translate }}</p>
        </div>
      } @else {
        <div class="archive-list">
          @for (archive of archives; track archive.id) {
            <button class="archive-row" (click)="onSelect(archive)">
              <fa-icon [icon]="faFile" class="archive-icon"></fa-icon>
              <span class="archive-name">{{ archive.name }}</span>
            </button>
          }
        </div>
      }
    </div>
  </div>
</div>
